module.exports = __webpack_public_path__ + "web/img/s5.9c1a8d8d.png";